module.exports = __webpack_public_path__ + "img/mhmet-kirci@2x.d71a8328.png";